<template>
  <div
    v-if="showPwaInstall && pwaShowPwaInstall"
    class="pwa-home"
    :class="{ 'pwa-home-result': isResultPage }"
  >
    <div class="pwa-home-bg" :style="pwaHomeStyle"></div>
    <pwa-install-top :location="location">
      <template #customerBtn>
        <p class="pwa-home-text">{{ letter.v3AddShortcutForBonus }}</p>
        <a
          class="pwa-home-close"
          href="javascript:void(0)"
          @click="handleHeaderPwaInstall($event, false)"
          >&times;</a
        >
      </template>
    </pwa-install-top>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import globalConfig from '@utiles/officialStore/globalConfig';
import { isSafari } from '@utiles/officialStore/device';
import PwaInstallTop from '@components/officialTopupNew/pwa/PwaInstallTop.vue';
import { SET_PWA_STATUS } from '@store/officialTopupNew/activity';
import { UPDATE_IS_INSTALL } from '@store/officialTopupNew/page';
import pwaMixin from '@mixins/pwa';
import { GET_AWARD_BASIC } from '@store/officialTopupNew/award';
import bridge from '@utiles/officialStore/bridge';
export default {
  name: 'PwaInstallHome',
  components: { PwaInstallTop },
  props: ['isResultPage', 'location'],
  data() {
    return {
      isSafari: isSafari(),
      isHideAdd:
        globalConfig.getHrefParam('cid') === 'shortcut' ||
        globalConfig.getHrefParam('scid').includes('shortcut') ||
        globalConfig.getHrefParam('scid') == 'newpwa' ||
        globalConfig.getHrefParam('mode') == 'pwa',
      boolCanGetAward: false
    };
  },
  mixins: [pwaMixin],
  computed: {
    ...mapState({
      letter: state => state.letter,
      picList: state => state.page.picList,
      showPwaInstall: state => state.activity.showPwaInstall,
      isInstall: state => state.page.isInstall,
      openPwa: state => state.page.openPwa,
      isClosePwaPopup: state => state.page.isClosePwaPopup
    }),
    ...mapGetters(['isJpPlatform']),
    pwaHomeStyle() {
      return `background-image: url(${this.picList.mPwa})`;
    },
    gameId() {
      return this.$store.state.gameId;
    },
    pwaShowPwaInstall() {
      if (this.gameId == 191) {
        return (
          this.openPwa &&
          !this.isHideAdd &&
          !this.isClosePwaPopup &&
          !bridge.runInsdk()
          // this.boolCanGetAward // todo:暂留，周一开
        );
      }
      return (
        this.openPwa &&
        !this.isHideAdd && // pwa进入不展示
        (this.isSafari || !this.isInstall?.value) && // 已安装不展示，safari展示
        !this.isJpPlatform // 日本平台不展示
      );
    },
    async initAward() {
      const res = await this.$store.dispatch(GET_AWARD_BASIC);
      if (+res?.result === 1 && res?.data?.giftList?.length > 0) {
        const awardInfo = res?.data?.giftList?.find(
          item => item?.groupId === 'no_sendCoupon'
        );
        if (awardInfo?.list?.length > 0) {
          const awardInfItem = awardInfo?.list[0];
          if (awardInfItem?.hasOwnProperty('awardState')) {
            // 可以领取。
            this.boolCanGetAward = +awardInfItem?.awardState === 1;
            return;
          }
        }
      }
      // 不可以领取
      this.boolCanGetAward = false;
    }
  },
  methods: {
    handleHeaderPwaInstall(e, state) {
      e.stopPropagation();
      this.$store.commit(SET_PWA_STATUS, state);
    }
  },
  created() {
    // // todo:暂留，周一开
    // if (this.gameId == 191) {
    //   this.initAward();
    // }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/_dimen.scss';
.pwa-home {
  box-sizing: border-box;
  z-index: 30;
  position: relative;
  width: 100%;
  height: 120px;
  margin: 30px auto 0;
  padding: 0 40px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;

  &.pwa-home-result {
    padding: 0 20px;
    height: 100px;
    .pwa-home-bg {
      width: calc(100% - 40px);
    }
    .pwa-home-text {
      top: 20px;
      right: 80px;
      font-size: 18px;
      width: 300px;
    }
  }

  &-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: calc(100% - 80px);
    height: 100%;
    margin: auto;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: right 52%;
    border-radius: 10px;
  }

  &-text {
    z-index: 1;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 30px;
    right: 110px;
    width: 330px;
    height: 68px;
    line-height: 1.2;
    font-size: 22px;
    font-weight: bold;
    text-align: center;
    color: #fff;
  }

  &-close {
    z-index: 3;
    box-sizing: border-box;
    position: absolute;
    right: 0;
    top: 0;
    width: 44px;
    height: 44px;
    padding-left: 10px;
    padding-top: 2px;
    background-color: rgba(0, 0, 0, 0.7);
    color: #fff;
    font-size: 34px;
    font-weight: normal;
    text-align: center;
    border-radius: 0 12px 0 60px;
  }
}

::v-deep .pwa-install-wrap {
  z-index: 2;
  position: relative;
}

@media screen and (min-width: 768px) {
  .pwa-home {
    &-text {
      right: 210px;
    }
  }
}
</style>
